// Devices list page — CRUD + commands (wake / shutdown / schedule / register).

(function ($) {
  'use strict';

  if ($('#device-tbody').length === 0) return;

  // Tailwind classes for the primary/danger buttons in dialogs.
  var BTN_PRIMARY = 'bg-orange-500 hover:bg-orange-600 text-white';
  var BTN_DANGER  = 'bg-red-500 hover:bg-red-600 text-white';

  function readForm() {
    return {
      name: $('#device-name').val().trim(),
      host: $('#device-host').val().trim(),
      port: $('#device-port').val(),
      os_type: $('#device-os_type').val(),
      protocol: $('#device-protocol').val(),
      mac_address: $('#device-mac_address').val().trim(),
      broadcast_ip: $('#device-broadcast_ip').val().trim(),
      connection_timeout: $('#device-connection_timeout').val(),
      username: $('#device-username').val().trim(),
      password: $('#device-password').val(),
      auto_shutdown_enabled: $('#device-auto_shutdown_enabled').is(':checked') ? '1' : '',
    };
  }

  // ---------- Auto-shutdown rule (Teams-style: one time range + weekdays) ----------
  // The server JSON shape stays the same — `{"mon":[[s,e]], "tue":[[s,e]], ...}`
  // — but the UI only lets the user describe ONE contiguous window applied to
  // N weekdays. So we recover (start, end, days[]) from the JSON by:
  //   1. Picking the first day with any interval and using its [start,end].
  //   2. Including any other day whose intervals match that range.
  var RULE_DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function minutesToLabel(m) {
    if (m >= 24 * 60) return '24:00';
    return pad2(Math.floor(m / 60)) + ':' + pad2(m % 60);
  }

  function populateTimeSelect($sel, includeMidnightEnd) {
    // 30-min steps. Start dropdown stops at 23:30; end dropdown goes up to
    // 24:00 so a user can express "until midnight".
    var max = includeMidnightEnd ? 1440 : 1410;
    var html = '';
    for (var m = 0; m <= max; m += 30) {
      html += '<option value="' + m + '">' + minutesToLabel(m) + '</option>';
    }
    $sel.html(html);
  }

  function parseInitialRule($wrap) {
    var raw = $wrap.attr('data-schedule') || '{}';
    var schedule = {};
    try { schedule = JSON.parse(raw) || {}; } catch (e) {}
    var start = 9 * 60, end = 18 * 60, days = [];
    var firstRange = null;
    for (var i = 0; i < RULE_DAYS.length; i++) {
      var ivs = schedule[RULE_DAYS[i]] || [];
      if (!ivs.length) continue;
      // Treat the first interval of the first populated day as the canonical
      // range. Days whose first interval matches it become part of `days`.
      if (firstRange === null) {
        firstRange = [ivs[0][0], ivs[0][1]];
        start = firstRange[0];
        end = firstRange[1];
      }
      if (ivs[0][0] === firstRange[0] && ivs[0][1] === firstRange[1]) {
        days.push(RULE_DAYS[i]);
      }
    }
    return { start: start, end: end, days: days };
  }

  function applyRuleToInputs(rule) {
    $('#rule-start').val(rule.start);
    $('#rule-end').val(rule.end);
    $('.rule-day').each(function () {
      var $b = $(this);
      var active = rule.days.indexOf($b.data('day')) !== -1;
      setDayBtnActive($b, active);
    });
  }

  function setDayBtnActive($b, active) {
    $b.data('active', active ? 1 : 0);
    if (active) {
      $b.removeClass('border-slate-300 text-slate-600 dark:border-slate-600 dark:text-slate-300')
        .addClass('bg-orange-500 border-orange-500 text-white');
    } else {
      $b.removeClass('bg-orange-500 border-orange-500 text-white')
        .addClass('border-slate-300 text-slate-600 dark:border-slate-600 dark:text-slate-300');
    }
  }

  function initShutdownRule() {
    var $wrap = $('.auto-shutdown-rule');
    if (!$wrap.length || $wrap.data('initialized')) return;
    $wrap.data('initialized', true);
    populateTimeSelect($('#rule-start'), false);
    populateTimeSelect($('#rule-end'), true);
    var rule = parseInitialRule($wrap);
    applyRuleToInputs(rule);
  }

  // Weekday circle toggle.
  $(document).on('click', '.rule-day', function () {
    var $b = $(this);
    setDayBtnActive($b, !$b.data('active'));
  });

  // Build the JSON the server expects from the current rule controls.
  function serializeShutdownRule() {
    var start = parseInt($('#rule-start').val(), 10);
    var end = parseInt($('#rule-end').val(), 10);
    var out = {};
    if (!(start >= 0 && end > start)) return out;  // invalid → empty schedule
    $('.rule-day').each(function () {
      var $b = $(this);
      if ($b.data('active')) out[$b.data('day')] = [[start, end]];
    });
    return out;
  }
  // Expose for the modal Save handler.
  window.__serializeShutdownRule = serializeShutdownRule;
  window.__initShutdownRule = initShutdownRule;

  // When the user flips the protocol dropdown inside an open modal,
  // swap the port input to the default for that protocol — but only
  // if the current port still matches the OTHER protocol's default
  // (i.e. the admin hasn't typed a custom value).
  var PROTOCOL_DEFAULT_PORTS = { rdp: '3389', vnc: '5900' };
  $(document).on('change', '#device-protocol', function () {
    var newProto = $(this).val();
    var $port = $('#device-port');
    var current = String($port.val() || '').trim();
    if (current === '' || current === '3389' || current === '5900') {
      $port.val(PROTOCOL_DEFAULT_PORTS[newProto] || current);
    }
  });

  function patchRow($row, fields) {
    if (fields.name !== undefined) $row.find('.row-name').text(fields.name);
    if (fields.host !== undefined && fields.port !== undefined) {
      var protoBadge = $row.find('.row-protocol').prop('outerHTML') || '';
      $row.find('.row-host').html(
        protoBadge +
        $('<div>').text(fields.host).html() +
        '<span class="text-slate-400">:' + fields.port + '</span>'
      );
    }
    if (fields.protocol !== undefined) {
      var p = fields.protocol;
      var cls = p === 'vnc'
        ? 'bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300'
        : 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300';
      $row.find('.row-protocol')
        .removeClass()
        .addClass('row-protocol inline-block mr-1 px-1.5 py-0.5 rounded text-[10px] font-sans uppercase ' + cls)
        .text(p);
    }
    if (fields.os_type !== undefined) {
      var icon = fields.os_type === 'windows' ? 'bi-windows' : 'bi-ubuntu';
      var label = fields.os_type === 'windows' ? 'Windows' : 'Linux';
      $row.find('.row-os_type').html('<i class="bi ' + icon + ' mr-1"></i> ' + label);
    }
    // Countdown chip: hide instantly if auto-shutdown was just disabled.
    if (fields.next_shutdown_at !== undefined) {
      var $cd = $row.find('.row-shutdown-countdown');
      if ($cd.length) {
        if (fields.next_shutdown_at) {
          $cd.attr('data-fire-at', fields.next_shutdown_at)
             .removeClass('text-slate-400')
             .addClass('text-amber-700 dark:text-amber-300');
          if ($cd.find('.countdown-value').length === 0) {
            $cd.html('<i class="bi bi-clock-history"></i> <span class="countdown-value">…</span>');
          }
        } else {
          $cd.attr('data-fire-at', '').html('');
        }
        if (window.tickShutdownCountdowns) window.tickShutdownCountdowns();
      }
    }
  }

  // ---------- Add ----------
  $(document).on('click', '.device-add-btn', function () {
    $.get('/api/devices/modal/add/', function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Add device', resp.html, { size: '2xl' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Create',
          class: BTN_PRIMARY,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            $.post('/api/devices/add/', readForm())
              .done(function (r) {
                if (r.ok) {
                  $('#device-tbody').prepend(r.row_html);
                  Toast.show('Device added', 'success');
                  dlg.hide();
                } else { Toast.show(r.error || 'Failed', 'error'); lb.stop('Create'); }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Failed', 'error');
                lb.stop('Create');
              });
          },
        },
      ]).show();
    });
  });

  // ---------- Edit ----------
  $(document).on('click', '.device-edit-btn', function () {
    var $row = $(this).closest('tr');
    var id = $row.data('id');
    $.get('/api/devices/modal/update/', { id: id }, function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Edit device', resp.html, { size: '2xl' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Save',
          class: BTN_PRIMARY,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            $.post('/api/devices/' + id + '/update/', readForm())
              .done(function (r) {
                if (r.ok) { patchRow($row, r.fields); Toast.show('Saved', 'success'); dlg.hide(); }
                else { Toast.show(r.error || 'Failed', 'error'); lb.stop('Save'); }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Failed', 'error');
                lb.stop('Save');
              });
          },
        },
      ]).show();
    });
  });

  // ---------- Auto-shutdown schedule (dedicated modal) ----------
  $(document).on('click', '.device-schedule-config-btn', function () {
    var id = $(this).data('id');
    $.get('/api/devices/modal/auto-shutdown/', { id: id }, function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Auto-shutdown schedule', resp.html, { size: 'lg' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Save',
          class: BTN_PRIMARY,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            var schedule = JSON.stringify(window.__serializeShutdownRule());
            // Flip sign so positive = east of UTC (IST = +330).
            var tzOffset = -new Date().getTimezoneOffset();
            $.post('/api/devices/' + id + '/auto-shutdown/', {
              auto_shutdown_schedule: schedule,
              auto_shutdown_tz_offset: tzOffset,
            })
              .done(function (r) {
                if (r.ok) {
                  var $row = $('#device-tbody tr[data-id="' + id + '"]');
                  if ($row.length && r.fields) patchRow($row, r.fields);
                  Toast.show('Schedule saved', 'success');
                  dlg.hide();
                } else { Toast.show(r.error || 'Failed', 'error'); lb.stop('Save'); }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Failed', 'error');
                lb.stop('Save');
              });
          },
        },
      ]).show();
      window.__initShutdownRule();
    });
  });

  // ---------- Delete ----------
  $(document).on('click', '.device-delete-btn', function () {
    var $row = $(this).closest('tr');
    var id = $row.data('id');
    $.get('/api/devices/modal/delete/', { id: id }, function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Delete device', resp.html, { size: 'sm' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Delete',
          class: BTN_DANGER,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            $.post('/api/devices/' + id + '/delete/')
              .done(function (r) {
                if (r.ok) { $row.remove(); Toast.show('Device deleted', 'success'); dlg.hide(); }
                else { Toast.show(r.error || 'Failed', 'error'); lb.stop('Delete'); }
              })
              .fail(function () { Toast.show('Failed', 'error'); lb.stop('Delete'); });
          },
        },
      ]).show();
    });
  });

  // ---------- Register token ----------
  $(document).on('click', '.device-register-btn', function () {
    var id = $(this).closest('tr').data('id');
    $.get('/api/devices/modal/register/', { id: id }, function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Registration token', resp.html, { size: 'lg' });
      dlg.setButtons([
        { name: 'Close', dismiss: true },
        {
          name: 'Generate token',
          class: BTN_PRIMARY,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            $.post('/api/devices/' + id + '/register-token/')
              .done(function (r) {
                if (r.ok) {
                  var html =
                    '<div class="space-y-2">' +
                      '<label class="block text-sm">One-time registration token (expires ' +
                        $('<div>').text(new Date(r.expires_at).toLocaleString()).html() + '):</label>' +
                      '<div class="flex gap-2">' +
                        '<input id="reg-token" type="text" readonly value="' +
                          $('<div>').text(r.token).html() + '" ' +
                          'class="flex-1 px-3 py-2 rounded border border-slate-300 bg-slate-50 text-slate-900 font-mono text-xs ' +
                          'dark:bg-slate-900 dark:border-slate-600 dark:text-slate-100">' +
                        '<button id="reg-copy" class="px-3 py-2 rounded bg-orange-500 hover:bg-orange-600 text-white text-sm">' +
                          '<i class="bi bi-clipboard"></i> Copy</button>' +
                      '</div>' +
                      '<p class="text-xs text-slate-500">Run on the PC: ' +
                        '<code>agenticlab-agent register --token ' + $('<div>').text(r.token).html() +
                        ' --server &lt;your-server&gt;</code></p>' +
                    '</div>';
                  $('#device-register-output').html(html);
                  Toast.show('Token generated', 'success');
                  lb.stop('Regenerate');
                } else { Toast.show(r.error || 'Failed', 'error'); lb.stop('Generate token'); }
              });
          },
        },
      ]).show();
    });
  });
  $(document).on('click', '#reg-copy', function () {
    var $i = $('#reg-token'); $i[0].select();
    try { document.execCommand('copy'); Toast.show('Copied', 'success'); }
    catch (e) { Toast.show('Copy failed', 'error'); }
  });

  // ---------- Wake on LAN ----------
  // Track devices currently in the "waking" state so we don't double-poll
  // if the operator clicks Wake twice on the same row.
  var waking = {};
  var WAKE_POLL_MS = 10000;     // 10s between checks
  var WAKE_TIMEOUT_MS = 180000; // 3 min total before giving up

  function setRowWaking($row, on) {
    var $btn = $row.find('.device-wake-btn');
    if (on) {
      $btn.prop('disabled', true)
          .attr('title', 'Waking...')
          .html('<i class="bi bi-arrow-clockwise spin"></i>');
    } else {
      $btn.prop('disabled', false)
          .attr('title', 'Wake on LAN')
          .html('<i class="bi bi-power"></i>');
    }
  }

  function pollUntilOnline(id, $row, deadline) {
    $.get('/api/devices/statuses/').done(function (resp) {
      var devices = (resp && resp.devices) || [];
      var found = devices.find(function (d) { return d.id_str === id; });
      if (found && found.status === 'online') {
        setRowWaking($row, false);
        waking[id] = false;
        Toast.show('Device is online', 'success');
        // Refresh the status pill immediately too.
        $row.find('.row-status').html(
          '<span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs ' +
          'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300">' +
          '<span class="w-1.5 h-1.5 rounded-full bg-green-500"></span> Online</span>'
        );
        return;
      }
      if (Date.now() > deadline) {
        setRowWaking($row, false);
        waking[id] = false;
        Toast.show('Wake timed out — device did not come online', 'error');
        return;
      }
      setTimeout(function () { pollUntilOnline(id, $row, deadline); }, WAKE_POLL_MS);
    }).fail(function () {
      // Network blip — retry on the same cadence.
      setTimeout(function () { pollUntilOnline(id, $row, deadline); }, WAKE_POLL_MS);
    });
  }

  $(document).on('click', '.device-wake-btn', function () {
    var $row = $(this).closest('tr');
    var id = $row.data('id');
    if (waking[id]) return;
    waking[id] = true;
    setRowWaking($row, true);
    $.post('/api/devices/' + id + '/wake/')
      .done(function (r) {
        if (!r.ok) {
          Toast.show(r.error || 'Failed', 'error');
          setRowWaking($row, false);
          waking[id] = false;
          return;
        }
        Toast.show('WoL sent — waiting for agent...', 'info');
        pollUntilOnline(id, $row, Date.now() + WAKE_TIMEOUT_MS);
      })
      .fail(function () {
        Toast.show('Failed', 'error');
        setRowWaking($row, false);
        waking[id] = false;
      });
  });

  // ---------- Shutdown now ----------
  $(document).on('click', '.device-shutdown-btn', function () {
    var $row = $(this).closest('tr');
    var id = $row.data('id');
    if (!confirm('Shutdown ' + $row.find('.row-name').text() + ' now?')) return;
    $.post('/api/devices/' + id + '/shutdown/')
      .done(function (r) { Toast.show(r.ok ? 'Shutdown command sent' : (r.error || 'Failed'), r.ok ? 'success' : 'error'); })
      .fail(function (xhr) { Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Failed', 'error'); });
  });

  // ---------- Schedule shutdown ----------
  $(document).on('click', '.device-schedule-btn', function () {
    var id = $(this).closest('tr').data('id');
    $.get('/api/devices/modal/schedule/', { id: id }, function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Schedule shutdown', resp.html, { size: 'md' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Schedule',
          class: BTN_PRIMARY,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            var fireAt = $('#device-fire_at').val();
            if (!fireAt) { Toast.show('Pick a time', 'error'); lb.stop('Schedule'); return; }
            // datetime-local returns a string in the user's local timezone
            // ("2026-05-27T15:03"). Convert it to a UTC ISO string before
            // sending; the server is configured for UTC and would otherwise
            // misinterpret the local time.
            var fireAtUtc = new Date(fireAt).toISOString();
            $.post('/api/devices/' + id + '/schedule/', { fire_at: fireAtUtc })
              .done(function (r) {
                if (r.ok) {
                  Toast.show('Shutdown scheduled', 'success');
                  // Swap the row's clock icon to the "cancel" variant
                  // immediately so the admin doesn't have to wait 60s.
                  var $row = $('#device-tbody tr[data-id="' + id + '"]');
                  $row.find('.device-schedule-btn').replaceWith(
                    '<button class="device-cancel-schedule-btn p-1.5 text-amber-600 hover:text-red-600" ' +
                    'title="Cancel scheduled shutdown"><i class="bi bi-clock-fill"></i></button>'
                  );
                  dlg.hide();
                } else { Toast.show(r.error || 'Failed', 'error'); lb.stop('Schedule'); }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Failed', 'error');
                lb.stop('Schedule');
              });
          },
        },
      ]).show();
    });
  });

  // ---------- Cancel scheduled shutdown ----------
  // Shown only when a pending schedule exists (the icon turns amber). Click
  // confirms then cancels every pending schedule on this device.
  $(document).on('click', '.device-cancel-schedule-btn', function () {
    var $btn = $(this);
    var $row = $btn.closest('tr');
    var id = $row.data('id');
    var name = $row.find('.row-name').text();
    if (!confirm('Cancel the scheduled shutdown for ' + name + '?')) return;
    $.post('/api/devices/' + id + '/cancel-schedule/')
      .done(function (r) {
        if (!r.ok) {
          Toast.show(r.error || 'Failed', 'error');
          return;
        }
        Toast.show('Scheduled shutdown cancelled', 'success');
        // Clear the row's countdown chip + flip the icon back to "Schedule".
        var $cd = $row.find('.row-shutdown-countdown');
        if ($cd.length) { $cd.attr('data-fire-at', '').html(''); }
        $btn.replaceWith(
          '<button class="device-schedule-btn p-1.5 text-slate-500 hover:text-amber-600" ' +
          'title="Schedule shutdown"><i class="bi bi-clock"></i></button>'
        );
      })
      .fail(function (xhr) {
        Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Failed', 'error');
      });
  });

  // ---------- Self-update ----------
  // One device: confirm, fire-and-forget; server publishes self_update over MQTT.
  $(document).on('click', '.device-update-btn', function () {
    var $row = $(this).closest('tr');
    var id = $row.data('id');
    if (!confirm('Push the latest agent build to ' + $row.find('.row-name').text() + '? '
                 + 'The agent will restart and may briefly drop offline.')) return;
    $.post('/api/devices/' + id + '/update-agent/')
      .done(function (r) {
        Toast.show(r.ok ? 'Update triggered' : (r.error || 'Failed'),
                   r.ok ? 'success' : 'error');
      })
      .fail(function (xhr) {
        Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Failed', 'error');
      });
  });

  // All online registered devices.
  $(document).on('click', '.device-update-all-btn', function () {
    if (!confirm('Push the latest agent build to ALL online devices? '
                 + 'Each will restart and may briefly drop offline.')) return;
    var $btn = $(this);
    // LoadingButton.stop(text) does `button.textContent = text`, which
    // escapes any HTML we pass in (icon markup becomes literal "<i...>").
    // Snapshot the original innerHTML and restore it manually.
    var originalHtml = $btn.html();
    var lb = new LoadingButton(this); lb.start();
    function restore() { lb.stop(''); $btn.html(originalHtml); }
    $.post('/api/devices/update-all-agents/')
      .done(function (r) {
        if (r.ok) {
          Toast.show('Update triggered on ' + r.count + ' device(s)', 'success');
        } else {
          Toast.show(r.error || 'Failed', 'error');
        }
        restore();
      })
      .fail(function (xhr) {
        Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Failed', 'error');
        restore();
      });
  });

  // ---------- Auto-refresh status column every 60s ----------
  function refreshStatuses() {
    $.get('/api/devices/statuses/').done(function (resp) {
      if (!resp || !Array.isArray(resp.devices)) return;
      resp.devices.forEach(function (d) {
        var $row = $('#device-tbody tr[data-id="' + d.id_str + '"]');
        if (!$row.length) return;
        var pill = '';
        if (d.status === 'online') {
          pill = '<span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs ' +
                 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300">' +
                 '<span class="w-1.5 h-1.5 rounded-full bg-green-500"></span> Online</span>';
        } else if (d.status === 'offline') {
          pill = '<span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs ' +
                 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300">' +
                 '<span class="w-1.5 h-1.5 rounded-full bg-red-500"></span> Offline</span>';
        } else {
          pill = '<span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs ' +
                 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200">' +
                 '<span class="w-1.5 h-1.5 rounded-full bg-slate-400"></span> Unknown</span>';
        }
        $row.find('.row-status').html(pill);
        $row.find('.row-last_seen').text((d.last_seen_str || '—').slice(0, 19));
        // Auto-shutdown countdown is in the same cell.  Refresh data-fire-at
        // so the app.js ticker picks up new/cancelled schedules.
        var $countdown = $row.find('.row-shutdown-countdown');
        if ($countdown.length) {
          if (d.next_shutdown_at) {
            $countdown.attr('data-fire-at', d.next_shutdown_at)
                      .removeClass('text-slate-400')
                      .addClass('text-amber-700 dark:text-amber-300');
            if ($countdown.find('.countdown-value').length === 0) {
              $countdown.html('<i class="bi bi-clock-history"></i> <span class="countdown-value">…</span>');
            }
          } else {
            $countdown.attr('data-fire-at', '').html('');
          }
        }
        // Keep the schedule/cancel icon in sync with whether a schedule
        // is currently pending (handles changes made in another browser
        // or by the auto-shutdown system).
        var $sched = $row.find('.device-schedule-btn');
        var $cancel = $row.find('.device-cancel-schedule-btn');
        if (d.next_shutdown_at) {
          if ($sched.length && !$cancel.length) {
            $sched.replaceWith(
              '<button class="device-cancel-schedule-btn p-1.5 text-amber-600 hover:text-red-600" ' +
              'title="Cancel scheduled shutdown"><i class="bi bi-clock-fill"></i></button>'
            );
          }
        } else {
          if ($cancel.length && !$sched.length) {
            $cancel.replaceWith(
              '<button class="device-schedule-btn p-1.5 text-slate-500 hover:text-amber-600" ' +
              'title="Schedule shutdown"><i class="bi bi-clock"></i></button>'
            );
          }
        }
      });
      if (window.tickShutdownCountdowns) window.tickShutdownCountdowns();
    });
  }
  setInterval(refreshStatuses, 60000);

})(jQuery);
